import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CategoryPage from '../../components/CategoryPage';
import { categoryContent } from '../../data/categoryContent';
import SEO from '../../components/SEO';
import { untranslateCategorySlug } from '../../i18n/routes';
import { useLocale } from '../../context/LocaleContext';

const CATEGORY_SEO_KEYS: Record<string, string> = {
  'earrings-and-hoops': 'categoryEarrings',
  'rings': 'categoryRings',
  'unique-finds': 'categoryUniqueFinds',
};

const CategoryPageWrapper: React.FC = () => {
  const { category: rawCategory } = useParams<{ category: string }>();
  const { locale } = useLocale();
  const { t } = useTranslation();

  // Untranslate the slug (e.g. 'anelli' → 'rings' when locale is 'it')
  const category = rawCategory ? untranslateCategorySlug(rawCategory, locale) : undefined;

  if (!category || !categoryContent[category]) {
    return <Navigate to="/404" replace />;
  }

  const content = categoryContent[category];
  const seoKey = CATEGORY_SEO_KEYS[category];

  return (
    <>
      <SEO
        title={seoKey ? t(`seo.${seoKey}.title`) : content.title}
        description={seoKey ? t(`seo.${seoKey}.description`) : content.seoDescription}
        noindex={false}
        image={content.heroImage}
      />
      <CategoryPage {...content} />
    </>
  );
};

export default CategoryPageWrapper;
